import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Fade } from "./Fade";

export function FinalCTA() {
  return (
    <section className="bg-white text-[hsl(222_47%_11%)] px-5 sm:px-8 md:px-10 py-20 sm:py-28">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <Fade>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-[-0.02em] mb-4">
                Ready to join Growth Lever?
              </h2>
            </Fade>
            <Fade delay={0.05}>
              <p className="text-black/45 text-base max-w-md mb-8 leading-relaxed">
                Your top-performing campaigns deserve more capital. Unlock funding, scale with precision,
                and maximize every opportunity. Get started in minutes, or book a demo to learn more.
              </p>
            </Fade>
            <Fade delay={0.1}>
              <div className="flex flex-wrap items-center gap-4">
                <Link
                  to="/auth?tab=signup"
                  className="inline-flex items-center gap-2 bg-[hsl(222_47%_11%)] text-white font-semibold text-sm px-7 py-3 rounded-full hover:bg-[hsl(222_47%_16%)] transition-colors"
                >
                  Start free <ArrowRight className="h-4 w-4" />
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-white font-semibold text-sm bg-[hsl(217_91%_60%)] px-7 py-3 rounded-full hover:bg-[hsl(217_91%_65%)] transition-colors"
                >
                  Book a demo
                </Link>
              </div>
            </Fade>
          </div>

          {/* Product screenshot */}
          <Fade delay={0.15} y={16}>
            <div className="border border-black/10 rounded-lg overflow-hidden shadow-xl">
              <img
                src="/screenshots/dashboard.png"
                alt="Growth Lever platform dashboard"
                className="w-full h-auto"
                loading="lazy"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
}
